import * as Yup from 'yup';

// SAFETY MESSAGE AND LOGO VALIDATION SCHEMA
export const SafetyMessageAndLogoSchema = Yup.object().shape({
  safetyMessage: Yup.string().max(320, 'Maximum 320 Characters'),
  logo: Yup.mixed()
    .test('fileSize', 'Please upload a file within the 1MB limit.', (value) => {
      if (value?.size) {
        const maxFileSize = 1024 * 1024; // 1 MB
        return value.size <= maxFileSize;
      }
      return true;
    })
    .test(
      'fileType',
      'Only .png, .jpg, and .jpeg files are allowed.',
      (value) => {
        if (value) {
          // Only validate file type for new File objects being uploaded
          // Skip validation for existing logos (which don't have a 'type' property)
          // This is because we don't store the file type in the database
          if (value instanceof File) {
            const acceptedFormats = ['image/jpeg', 'image/jpg', 'image/png'];
            return acceptedFormats.includes(value.type);
          }
          // For existing logos (not File objects), always pass validation
          return true;
        }
        return true;
      }
    )
});
